import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'ras-site-tour',
	templateUrl: './site-tour.component.html',
	styleUrls: ['./site-tour.component.sass']
})
export class SiteTourComponent implements OnInit {

	@Output() close = new EventEmitter()
	@Input() img: string
	@Input() thumb: string
	_numFrames: number = 0
	@Input()
	set numFrames(value: number) {
		this._numFrames = value
		this.imgs = []
		for (let i = 0; i < value; i += 1) {
			this.imgs.push(this.img.replace('%d', (i + 1).toString().padStart(2, '0')))
		}
	}

	public imgs: string[] = []

	public current_image: number = 0

	constructor() { }

	ngOnInit() {
	}

}
